import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import moment from 'moment'

import Modal from '../../../UniformComponents/Modal'
import Checkbox from '../../form/Checkbox'
import Select from '../../form/Select'
import Button from '../../../UniformComponents/Button'
import Date from '../../form/Date'
import Typography from '../../../UniformComponents/Typography'

const ScheduleEmailModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.scheduleEmailModalVisible}
        onClose={distributeStore.hideScheduleEmailModal}
    >
        <Typography type="h2">{i18n.t('distributionScheduleEmailModal.title')}</Typography>

        <br />

        <div className="email-builder-modal-content">
            <Select
                label={i18n.t('sch_email_send_to_label')}
                options={distributeStore.emailListOptions}
                onBlur={distributeStore.changeEmailList}
                defaultValue={distributeStore.scheduleUserLists.map((list) => list.value)}
                isMulti
            />

            <div className="schedule-email-modal-date-time-container">
                <div className="date">
                    <Date
                        label={i18n.t('sch_email_date_to_send_label')}
                        placeholder={i18n.t('form.date.placeholder')}
                        minDate={moment.utc()}
                        value={moment(distributeStore.selectedEmailSendDateTime).tz(distributeStore.store.timeZone)}
                        onBlur={distributeStore.changeSendDate}
                        dateFormat="DD/MM/YYYY"
                        allowManualDateEdit
                    />
                </div>
                <div className="time">
                    <Date
                        label={i18n.t('sch_email_time_to_send_label')}
                        placeholder={i18n.t('form.time.placeholder')}
                        value={moment(distributeStore.selectedEmailSendDateTime).tz(distributeStore.store.timeZone)}
                        onBlur={distributeStore.changeSendTime}
                        showTimeSelectOnly
                        showTimeSelect
                        dateFormat="HH:mm z"
                        calendarCss="timeOnlyFeild"
                        useGMT={false}
                    />
                </div>
            </div>

            <div className="schedule-email-modal-info-section">
                <Typography type="b">{i18n.t('distributionScheduleEmailModal.info-title')}</Typography>

                <br />

                <div className="schedule-email-modal-info-item">
                    <Typography>{i18n.t('distributionScheduleEmailModal.info-one')}</Typography>
                </div>

                <div className="schedule-email-modal-info-item">
                    <Typography>{i18n.t('distributionScheduleEmailModal.info-two')}</Typography>
                </div>

                <div className="schedule-email-modal-info-item">
                    <Typography>{i18n.t('distributionScheduleEmailModal.info-three')}</Typography>
                </div>

                <div className="schedule-email-modal-info-item">
                    <Typography>{i18n.t('distributionScheduleEmailModal.info-four')}</Typography>
                </div>

                <br />

                <Typography
                    cssClass="schedule-email-modal-info-subtext"
                >
                    {i18n.t('distributionScheduleEmailModal.info-confirm')}
                </Typography>

                <br />

                <hr />

                <br />

                <div className="schedule-email-modal-info-checkbox">
                    <Typography type="b">{i18n.t('distributionScheduleEmailModal.checkbox')}</Typography>

                    <Checkbox
                        onBlur={distributeStore.toggleScheduleEmailCheckbox}
                    />
                </div>
            </div>
        </div>

        <br />

        <hr />

        <br />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Button
                onClick={distributeStore.hideScheduleEmailModal}
                cssClass="regular tertiary"
                label={i18n.t('cancel')}
            />

            <div style={{ display: 'flex', gap: 20 }}>
                <Button
                    cssClass="regular primary"
                    disabled={!distributeStore.scheduleEmailChecked || !distributeStore.scheduleUserLists.length}
                    onClick={distributeStore.showSendNowModal}
                    label={i18n.t('sch_email_send_email_now_btn')}
                    icon="far fa-paper-plane-top"
                />

                <Button
                    cssClass="regular primary"
                    disabled={!distributeStore.scheduleEmailChecked || !distributeStore.scheduleUserLists.length}
                    onClick={() => distributeStore.scheduleEmail(false)}
                    icon="far fa-calendar-check"
                    label={i18n.t('sch_email_send_scheduled_email')}
                />
            </div>
        </div>
    </Modal>
)

export default observer(ScheduleEmailModal)
